<main-nav>
  <div id="page" class="routeMainLayer">
    <div id="maincontent" [@routeAnimations]="getRouterOutlet(mainLayerOutlet)" class="content">
      <router-outlet id="mainLayerOutlet" #mainLayerOutlet="outlet"></router-outlet>
    </div>
    <ya-main-footer></ya-main-footer>
  </div>
</main-nav>